module.exports = __webpack_public_path__ + "static/success-rocket-5077427badc83228fdd53b676a85f90b.png";